import React from "react";
import { Table } from "react-bootstrap";
import { formatNumberOnDashBoard, isValidArray } from "../../../helper";
import { get } from "lodash";

export default class ProjectLocationReport extends React.Component {
  render() {
    const { misData } = this.props;
    return (
      <Table responsive striped hover size="sm" className="mis-project-list">
        <thead>
          <tr>
            <th className="first-child">Status</th>
            <th className="child-between">Number of Projects</th>
            <th className="last-child">Cost(cr)</th>
          </tr>
        </thead>
        <tbody>
          {isValidArray(get(misData, "data")) &&
            misData.data.map((data, index) => {
              return (
                <tr key={index}>
                  <td className="child-between" title={data.name}>
                    {data.name}
                  </td>
                  <td className="first-child">{data.number}</td>
                  <td className="last-child">
                    {(data.cost && `${formatNumberOnDashBoard(data.cost)}`) ||
                      "NA"}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    );
  }
}
